module.exports = __webpack_public_path__ + "static/media/validacao_expressao_dark.30bd2c20.svg";